import React from 'react';
import { useSelector } from 'react-redux';
import produce from 'immer';

import {
  Text,
  Badge,
  Dropdown,
  CanAccess,
  WrapperFlex,
  TelefoneBox,
} from '@unimed-fesp/components';

import theme from '../../../styles/theme';

import {
  TipoPerfilUsuarioEnum,
  PermissaoContratanteEnum,
} from '../../../enums';

import InputForm from '../../atoms/InputForm';
import FadeIn from '../../atoms/FadeIn';

import LabelContainer from '../../molecules/LabelContainer';

import { isContratante, isAdmin } from '../../../utils/userRole';
import useParametrizazao from '../../../hooks/useParametrizazao';

const DadosGerais = ({
  usuarioParams,
  setUsuarioParams,
  usuarioDadosGerais,
  contatoParams,
  setContatoParams,
  useField,
}) => {
  const optionsPerfil = [
    {
      onClickOption: () => handleSelectedPerfil('Administrador'),
      text: 'Administrador',
    },
    {
      onClickOption: () => handleSelectedPerfil('Contratante'),
      text: 'Contratante',
    },
  ];

  const optionsPermissao = [
    {
      onClickOption: () => handleSelectedPermissao('Consulta'),
      text: 'Consulta',
    },
    {
      onClickOption: () => handleSelectedPermissao('Alteração'),
      text: 'Alteração',
    },
  ];

  const { usuario } = useSelector((state) => state.auth);
  const registerPerfil = useField('perfil').registerField;
  const registerPermissao = useField('permissao').registerField;
  const { handleRemoveAllCards } = useParametrizazao(usuarioParams?.idUsuario);

  function handleSelectedPerfil(text) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft.tipoPerfil !== text) draft.tipoPerfil = text;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  function handleSelectedPermissao(text) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft.permissao !== text) draft.permissao = text;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  function handleChange(e, status) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  return (
    <WrapperFlex column justifyCenter alignCenter>
      <FadeIn>
        <WrapperFlex column justifyCenter alignStart>
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Usuário"
            paddingBottom={20}
          />
          <LabelContainer text="Nome" marginBottom="30">
            <InputForm
              handleChange={(e) => handleChange(e, 'nome')}
              marginTop="9"
              width="623"
              height="40"
              placeholder="Informe o nome completo do usuário"
              name="nome"
              value={usuarioParams.nome}
            />
          </LabelContainer>
          {isContratante(usuarioDadosGerais.tipoPerfil) && (
            <LabelContainer text="Matrícula (Opcional)" marginBottom="30">
              <InputForm
                handleChange={(e) => handleChange(e, 'matricula')}
                marginTop="9"
                width="322"
                height="40"
                placeholder="Informe o número da matrícula"
                name="matricula"
                value={usuarioParams.matricula}
              />
            </LabelContainer>
          )}
          <CanAccess
            checkRole={{
              Administrador: TipoPerfilUsuarioEnum.returnNameForName.Adm,
            }}
            userRole={usuario.role}
          >
            <Dropdown
              options={optionsPerfil}
              tipo="dropdown"
              width={220}
              height={46}
              marginTop={9}
              marginBottom={30}
              labelText="Perfil"
              name="perfil"
              disable
              register={registerPerfil}
            >
              {usuarioParams.tipoPerfil === '' ||
              usuarioParams.tipoPerfil === null
                ? TipoPerfilUsuarioEnum.returnTipoPerfilAcessoForTipoPerfil
                    .Selecione
                : TipoPerfilUsuarioEnum.returnTipoPerfilAcessoForTipoPerfil[
                    usuarioParams.tipoPerfil
                  ]}
            </Dropdown>
          </CanAccess>
          {isAdmin(usuarioParams.tipoPerfil) && (
            <WrapperFlex marginTop={-25} gap={5} paddingLeft={5} width={500}>
              {usuarioParams.roles.map((role) => {
                const IS_ADM =
                  role === TipoPerfilUsuarioEnum.returnNameForName.Adm;

                return (
                  <Badge
                    text={
                      TipoPerfilUsuarioEnum.returnNameFormattedForName[role]
                    }
                    showBtnRemove={!IS_ADM}
                    onClick={() => !IS_ADM && handleRemoveAllCards()}
                  />
                );
              })}
            </WrapperFlex>
          )}
          {isContratante(usuarioParams.tipoPerfil) ||
          usuarioParams.tipoPerfil === 'Contratante' ? (
            <>
              <Dropdown
                options={optionsPermissao}
                tipo="dropdown"
                width={220}
                labelText="Permissão"
                name="permissao"
                marginTop={9}
                marginBottom={30}
                height={46}
                register={registerPermissao}
              >
                {usuarioParams.permissao == '' ||
                usuarioParams.permissao == null
                  ? PermissaoContratanteEnum.returnName[0]
                  : usuarioParams.permissao}
              </Dropdown>
            </>
          ) : null}
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Contato"
            paddingBottom={20}
            marginTop={30}
          />
          <TelefoneBox
            contatos={contatoParams.contatos}
            callbackChangeContatos={(contatos) =>
              setContatoParams({ contatos })
            }
          />
        </WrapperFlex>
      </FadeIn>
    </WrapperFlex>
  );
};

export default DadosGerais;
